import * as React from "react";
import PropTypes from "prop-types";
import MinimalBatteryIndicator from "nexia_mobile/components/MinimalBatteryIndicator";

function BatteryIndicator({ icon, inline, label, level, style }) {
  const fixedCornerStyle = {
    position: "absolute",
    top: "0.25em", // $base-margin
    left: "0.25em", // $base-margin
    textAlign: "left",
    fontSize: ".7em",
  };
  const inlineStyle = {
    display: "inline-block",
    textAlign: "left",
  };
  const indicatorStyle = Object.assign(
    {},
    inline ? inlineStyle : fixedCornerStyle,
    style
  );

  const ariaLevel = label === "?" ? "Unknown" : label;

  return (
    <div
      data-component-name="BatteryIndicator"
      style={indicatorStyle}
      aria-label={`Battery Level: ${ariaLevel}`}
    >
      <MinimalBatteryIndicator icon={icon} level={level} status={status} />
      {label}
    </div>
  );
}
BatteryIndicator.propTypes = {
  icon: PropTypes.string,
  inline: PropTypes.bool,
  label: PropTypes.string,
  level: PropTypes.number,
  style: PropTypes.object,
};

export default BatteryIndicator;



// WEBPACK FOOTER //
// ./src/components/BatteryIndicator.jsx